import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useEffect } from "react";
import { getPackage } from "../data/package.api";
import CustomTable from "../../../shared/CustomTable";
import moneyParser from "../../../shared/moneyParser";
import { InterfacePackageData } from "../data/package.interface";
import { Delete, Edit } from "@mui/icons-material";

export default function PackageTable(props: {
    onEdit?: (data: InterfacePackageData) => void,
    onDelete?: (id: number) => void
}) {

    const dispatch = useDispatch<any>()

    const { packageList } = useSelector((state: RootState) => state.package)

    useEffect(() => {
        dispatch(getPackage())
    }, [dispatch])

    return (
        <Box>
            <CustomTable
                columns={[
                    {
                        name: "Nama",
                        key: "name"
                    },
                    {
                        name: "Harga",
                        key: "price",
                        render: (data: InterfacePackageData) => (
                            <span>{moneyParser(data.price)}</span>
                        )
                    }
                ]}
                dataList={packageList}
                actionList={(props.onEdit || props.onDelete)
                    ? (data: InterfacePackageData) => (
                        <Box display={"flex"} justifyContent={"center"} gap={1}>
                            {props.onEdit && (<Button startIcon={<Edit />} color="warning" onClick={() => props.onEdit && props.onEdit(data)}>Edit</Button>)}
                            {props.onDelete && (<Button startIcon={<Delete />} color="error" onClick={() => props.onDelete && props.onDelete(data.id)}>Hapus</Button>)}
                        </Box>
                    )
                    : undefined
                }
            />
        </Box>
    )
}